import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GeneralService } from 'src/app/services/general.service';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { AppState } from 'src/app/store/app.state';
import { UserModel } from 'src/app/store/storeModels/user.model';

@Component({
  selector: 'app-dash-report',
  templateUrl: './dash-report.component.html',
  styleUrls: ['./dash-report.component.css']
})
export class DashReportComponent implements OnInit {
  user: UserModel
  sessionType;


  constructor(
    private email_service: EmailService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private gs: GeneralService,
  ) {
    store.select('userInfo').subscribe(info => this.user = info.user)
    this.route.queryParams.subscribe((res: any) => {
      const { session_type } = res;
      this.sessionType = session_type ? session_type : 'all';
    })
  }

  ngOnInit() {
    this.store.select('userInfo').subscribe(info => {
      if (Object.keys(info).length) {
        const { id, email } = info.user;

        this.email_service.email_context.next({
          name: 'dashboard',
          data: {
            id,
            email,
          },
        });
      }
    })
  }

  handleNavigation(session) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        session_type: session
      }
    };
    this.router.navigate(["/reports"], navigationExtras);
  }

}
